module.exports = __webpack_public_path__ + "static/img/news_78.504f0e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_78.png
// module id = G1U/
// module chunks = 2